import { WorkspacesSettingsRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/workspaces/')({
  component: WorkspacesSettingsRoute,
});
